export const LISTE_DELAI_REGLEMENT = {
  title: 'Liste des délais de règlement',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste délais règlement',
  },
  actions: {
    add: 'Ajouter un délai de règlement',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    estPersonnalisable: 'Personnalisable',
    nombreJourDecalage: 'Nb jours décalage',
    finDeMois: 'Fin de mois',
    jourFinDeMois: 'Jour fin du mois',
  },
};

export const ADD_DELAI_REGLEMENT = {
  titleAdd: 'Ajouter un délai de règlement',
  titleEdit: 'Modifier un délai de règlement',
  actions: {
    add: 'Ajouter',
    edit: 'Modifier',
    cancel: 'Annuler',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    endOfMonth: 'Le jour de fin de mois doit être compris en 1 et 31',
    noDetailDelaiReglement: 'Si le délai de règlement est personnalisable, impossible d\'avoir son détail',
    needFinDeMois: 'Le champ \'Fin de mois\' doit être coché pour remplir le champ \'Jour fin de mois\'',
  },
  informationDelaiReglement: {
    libelle: 'Libellé',
    personnalisable: 'Personnalisable',
    nombreJourDecalage: 'Nb de jours décalage',
    finDeMois: 'Fin de mois ',
    jourFinDeMois: 'Jour fin de mois',
  },
  success: {
    add: 'Le délai de règlement a été ajouté avec succès.',
    edit: 'Le délai de règlement a été modifié avec succès.',
  },
};
